import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { RemoveTeamMemberStyles } from "./styled";
import Icon from "components/Icon/Icon";
import { X } from "@phosphor-icons/react";
import Button from "components/Buttons";
import Select from "components/Select/index";

const RemoveTeamMember = ({
  show,
  onHide,
  rowData,
  step,
  creators = [],
  managersList,
  onRemove,
  onReassignAndRemove,
  loading
}) => {
  const [selectedManager, setSelectedManager] = useState(null);

  useEffect(() => {
    if (show) setSelectedManager(null);
  }, [show]);

  const visibleCreators = creators.slice(0, 2);
  const remainingCount = creators.length - visibleCreators.length;

  const managerOptions = useMemo(() => {
    return (managersList || []).map((manager) => ({
      label: manager.name,
      value: manager.id,
      bgColor: manager.bgColor
    }));
  }, [managersList]);

  return (
    <RemoveTeamMemberStyles
      show={show}
      className="centered-modal"
      onHide={onHide}
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      {/* HEADER */}
      <Modal.Header>
        <Modal.Title>
          {step === "cannot_reassign" ? (
            <>You can’t remove this user</>
          ) : (
            <>Remove {rowData?.name}?</>
          )}
        </Modal.Title>
        <div onClick={onHide} className="close-icon-wrapper">
          <Icon component={X} size={24} />
        </div>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body>
        {step !== "reassign" && step !== "cannot_reassign" && (
          <>
            Are you sure you want to remove this user? They’ll lose access to
            Signal immediately. You can add them back anytime.
          </>
        )}

        {step === "reassign" && (
          <>
            <p>
              <>{rowData?.name}</> currently manages{" "}
              <strong>
                {visibleCreators.map((c) => c.name).join(", ")}
                {remainingCount > 0 &&
                  `, and +${remainingCount} other creators. `}
              </strong>
              Reassign these creators to another manager before proceeding.
            </p>

            <div className="assign-dropdown">
              <Select
                id="new-manager"
                label="Assign to"
                placeholder="Select New Manager"
                options={managerOptions}
                value={selectedManager}
                onChange={(val) => setSelectedManager(val)}
              />
            </div>
          </>
        )}

        {step === "cannot_reassign" && (
          <>
            This manager is currently the only manager available. Please add
            another manager before removing them.
          </>
        )}
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        {step !== "reassign" && step !== "cannot_reassign" && (
          <Button
            variant="primary"
            colorScheme="error"
            loading={loading} // SHOW LOADER
            disabled={loading} // PREVENT DOUBLE CLICK
            onClick={() => onRemove(rowData)}
          >
            Yes, Remove
          </Button>
        )}

        {step === "cannot_reassign" && (
          <Button variant="primary" onClick={onHide}>
            Okay, got it{" "}
          </Button>
        )}

        {step === "reassign" && (
          <Button
            variant="primary"
            loading={loading} // SHOW LOADER
            disabled={!selectedManager || loading}
            onClick={() =>
              onReassignAndRemove({
                removedManagerId: rowData.talent_manager_id,
                newManagerId: selectedManager
              })
            }
          >
            Reassign & Remove
          </Button>
        )}
      </Modal.Footer>
    </RemoveTeamMemberStyles>
  );
};

export default RemoveTeamMember;
